import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { GridModule } from "@progress/kendo-angular-grid";
import { OrdenReparacionModule } from "../../../core/components/orden-reparacion/orden-reparacion.module";
import { VehiclesComponent } from "./vehicles.component";


@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        GridModule,
        OrdenReparacionModule
    ],
    declarations: [
        VehiclesComponent,
    ],
    exports: [
        VehiclesComponent,
    ]
})
export class VehiclesModule { }
